import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import api from '../services/api';

const CityContext = createContext(null);

export function CityProvider({ children }) {
  const [selectedCity, setSelectedCity] = useState(() => {
    try {
      const saved = localStorage.getItem('nc_city');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Busca cidades da API
  const fetchCities = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.get('/cities');
      // A API retorna array direto ou { data: [...] }? Vamos normalizar.
      const list = Array.isArray(data) ? data : (data.data || data.cities || []);
      setCities(list);
      // LE-010 fix: NÃO auto-selecionar cidade — o usuário deve escolher explicitamente.
      // (Cidade escolhida fica salva no localStorage via selectCity)
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Erro ao carregar cidades');
    } finally {
      setLoading(false);
    }
  }, [selectedCity]);

  useEffect(() => {
    fetchCities();
  }, []); // eslint-disable-line

  const selectCity = useCallback((city) => {
    setSelectedCity(city);
    try {
      localStorage.setItem('nc_city', JSON.stringify(city));
    } catch {}
  }, []);

  return (
    <CityContext.Provider value={{
      selectedCity,
      cities,
      selectCity,
      loading,
      error,
      refetch: fetchCities,
    }}>
      {children}
    </CityContext.Provider>
  );
}

export function useCity() {
  const ctx = useContext(CityContext);
  if (!ctx) throw new Error('useCity must be inside CityProvider');
  return ctx;
}
